import {
  Award,
  BadgeCheck,
  Boxes,
  Clock,
  Factory,
  FileText,
  Globe,
  Handshake,
  Layers,
  Mail,
  MapPin,
  MessageCircle,
  Package,
  Phone,
  Ruler,
  Scissors,
  SearchCheck,
  ShieldCheck,
  Shirt,
  Sparkles,
  Tag,
  Trophy,
  Truck,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { IconName } from '@/types/api';

const ICONS: Record<IconName, LucideIcon> = {
  award: Award,
  'badge-check': BadgeCheck,
  boxes: Boxes,
  clock: Clock,
  factory: Factory,
  'file-text': FileText,
  globe: Globe,
  handshake: Handshake,
  layers: Layers,
  mail: Mail,
  'map-pin': MapPin,
  'message-circle': MessageCircle,
  package: Package,
  phone: Phone,
  ruler: Ruler,
  scissors: Scissors,
  'search-check': SearchCheck,
  'shield-check': ShieldCheck,
  shirt: Shirt,
  sparkles: Sparkles,
  tag: Tag,
  trophy: Trophy,
  truck: Truck,
  zap: Zap,
};

/** Renders a content-configured icon; unknown names fall back to a neutral badge icon. */
export function Icon({ name, className }: { name: IconName | string; className?: string }) {
  const Component = ICONS[name as IconName] ?? BadgeCheck;
  return <Component className={className ?? 'h-4 w-4'} aria-hidden="true" />;
}
